module.exports = __webpack_public_path__ + "img/bg.96f21f17.png";